import { useState } from 'react';

import { Icon } from '@dcc-erp/ui';

import { HelpDrawer } from './HelpDrawer';

// Drop into a page's <PageHead actions> to surface that page's in-app user guide.
export function HelpButton({ guide }: { guide: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="btn ghost" onClick={() => setOpen(true)}>
        <Icon name="book" size={14} /> คู่มือ
      </button>
      {open && <HelpDrawer guideKey={guide} onClose={() => setOpen(false)} />}
    </>
  );
}
